var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmgenBlueLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 218.9 55.8",
    style: {
      enableBackground: "new 0 0 218.9 55.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0063C3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153,22.2h-28.6v12.5H140c-3.7,7.5-12.8,10.6-20.4,6.9c-7.5-3.7-10.6-12.8-6.9-20.4c2.5-5.2,7.8-8.5,13.6-8.5 c4.6-0.1,8.9,2.2,11.4,6h13.6C149.2,9.2,138.5,0,126.4,0c-11.8,0-23.3,7.7-25.7,19.1v0V2c-14.4,0-24,16.2-26.2,25.8h0 C72.2,18.2,62.7,2,48.3,2v51.5h12.5V23.8c0,0,7.2,6.4,7.2,29.6h12.9c0-23.2,7.2-29.6,7.2-29.6v29.6h12.5V35.5 c3,13,13.3,20.3,25.7,20.3c12.5,0,23.6-7.1,26.7-21v18.6c0,0,25.9,0,25.5,0V41.2h-13.3v-6.5h13.3V22.2h-13.3c0,0,0-6.9,0-6.9h13.3 V2.7H153L153,22.2z M206,24.1C195.1,8.5,184.5,2.8,181.6,2.8v50.7h13.3v-24c0,0,9.2,10,11.1,24h13V2.7h-13V24.1z M23.6,8.2 c-7.2,5.4-11.6,13.4-15,20.7C5.1,36.2,1.7,47.1,0,53.5h13c0.9-3.6,3.1-11.4,3.5-12.8h16.3v12.8h12.6V1.9C33.4,0.7,27,5.7,23.6,8.2 L23.6,8.2z M32.7,28.9h-11c2.6-4,6.9-9.2,11-12L32.7,28.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmgenBlueLogo);
export default __webpack_public_path__ + "static/media/AmgenBlueLogo.2aa1fed46bbb56cffa3cb50a06c5654a.svg";
export { ForwardRef as ReactComponent };